const { graphColors } = require('../../styles/colors')

const colors = Object.values(graphColors)
const knownColorCodings = {}

export default material => {
  if (!knownColorCodings[material]) knownColorCodings[material] = colors.shift()
  return knownColorCodings[material]
}
